import { useRegisteredDropTarget } from './e9295dbac6c8ac54a737b1e5ff78299dd8050f93b4f9815fe28c582a04a404b2.cfe-internal.js';
import { useOptionalFactory } from '../64a12a69d5d7c389d785a0a93b9c902a9672f22afbeb72d068e9ed9cec90f744.cfe-internal.js';
import { useDropTargetMonitor } from './93bc7c14c80e14cbfc502c6bd0a6dfc81e8cec125c80082ecc48b227890f7d93.cfe-internal.js';
import { useDropTargetConnector } from './0244defc797f057fabfd590daefaf8c7556814f6b8812f22a2d087ed0f5c5e08.cfe-internal.js';
import { useCollectedProps } from '../41c5075c709f9b2fe49407e3797456748c9c163ab6d486622b31fbbca6106b1f.cfe-internal.js';
import { useConnectDropTarget } from './aee94a474635d53d234968ddce927e825a5a4098812f14e9fe5028631b49d151.cfe-internal.js';

/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */
function useDrop(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  var monitor = useDropTargetMonitor();
  var connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDropTarget(connector)];
}

export { useDrop };
